export default "__VITE_ASSET__BxxLmLe1__"